/* ==========================================================================
   REMOVE ALL — cart drawer and cart page
   ==========================================================================
   One button, one confirmation, one implementation, wherever it is triggered
   from. Emptying a five-figure commercial cart by mis-tapping is not something
   an undo toast can fairly cover, so this is the one place that asks first.

   Deliberately does NOT touch the gym layout. Cart and layout are separate
   state: someone clearing the cart to re-price a build still wants the build.
   The confirmation says so out loud, because a shopper cannot see which way we
   wired it and should not have to guess.
   ========================================================================== */
(function () {
  'use strict';

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  var dialog = null;

  function closeDialog() {
    if (!dialog) return;
    dialog.remove();
    dialog = null;
    document.removeEventListener('keydown', onKey);
  }

  function onKey(e) {
    if (e.key === 'Escape') closeDialog();
  }

  function confirmClear(onYes) {
    closeDialog();

    dialog = document.createElement('div');
    dialog.className = 'ctx-clear';
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.setAttribute('aria-labelledby', 'ctxClearTitle');
    dialog.innerHTML =
      '<div class="ctx-clear__card">' +
        '<h2 class="ctx-clear__title" id="ctxClearTitle">Remove all items from your cart?</h2>' +
        '<p class="ctx-clear__text">This cannot be undone. Your gym layout and your saved answers are not affected &mdash; only the cart is emptied.</p>' +
        '<div class="ctx-clear__acts">' +
          '<button type="button" class="ctx-clear__no" data-ctx-clear-cancel>Cancel</button>' +
          '<button type="button" class="ctx-clear__yes" data-ctx-clear-yes>Remove all items</button>' +
        '</div>' +
      '</div>';

    document.body.appendChild(dialog);
    document.addEventListener('keydown', onKey);

    dialog.addEventListener('click', function (e) {
      /* Clicking the backdrop cancels; clicking inside the card does not. */
      if (e.target === dialog || e.target.closest('[data-ctx-clear-cancel]')) { closeDialog(); return; }
      if (e.target.closest('[data-ctx-clear-yes]')) {
        var btn = e.target.closest('[data-ctx-clear-yes]');
        btn.disabled = true;
        btn.textContent = 'Removing…';
        onYes(function () { closeDialog(); });
      }
    });

    var cancel = dialog.querySelector('[data-ctx-clear-cancel]');
    if (cancel) cancel.focus();
  }

  function clearCart(done) {
    fetch(root() + 'cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
    })
      .then(function () {
        done();
        /* On the cart page the whole page is the cart, so a reload is the
           honest redraw. Anywhere else only the drawer needs refreshing, and a
           reload would throw away whatever the shopper was in the middle of —
           a half-arranged gym, for instance. */
        if (/\/cart(\/|$|\?)/.test(location.pathname + location.search)) {
          location.reload();
          return;
        }
        if (typeof window.ctxRefreshAndOpenCart === 'function') {
          window.ctxRefreshAndOpenCart();
        } else {
          location.reload();
        }
      })
      .catch(function () {
        done();
        location.reload();
      });
  }

  /* Delegated from the document so it survives every drawer re-render — the
     drawer's innerHTML is replaced wholesale on each cart change, which takes
     any listener bound directly to a button with it. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-ctx-cart-clear]') : null;
    if (!btn) return;
    e.preventDefault();
    confirmClear(clearCart);
  });
})();
